import { Share } from "@capacitor/share";
import { Capacitor } from "@capacitor/core";
import { t } from "../i18n";

/** Live once the app is on the store; works as invite link today too. */
export const INVITE_URL = "https://apps.apple.com/app/id6799977452";

export async function shareRun(opts: {
  distance: number;
  coins: number;
  difficulty?: string;
  difficultyId?: string;
  name?: string;
  seed?: string;
  stage?: string;
}) {
  const meters = Math.floor(opts.distance);
  const who = opts.name?.trim();
  const diff = opts.difficulty ? ` (${opts.difficulty})` : "";
  const duelQs =
    opts.seed && meters > 0
      ? `?duel=${encodeURIComponent(opts.seed)}&m=${meters}&d=${encodeURIComponent(opts.difficultyId || "medium")}&s=${encodeURIComponent(opts.stage || "neon")}&n=${encodeURIComponent(who || "Courier")}`
      : "";
  const challenge = opts.seed
    ? t("shareChallenge", { url: `https://worldvelopers.com/3dash/${duelQs}` })
    : "";
  const text = who
    ? `${t("shareNamed", { who, meters, diff, challenge })}\n${INVITE_URL}`
    : `${t("shareAnon", { meters, coins: opts.coins, diff, challenge })}\n${INVITE_URL}`;

  if (Capacitor.isNativePlatform()) {
    try {
      await Share.share({
        title: "3Dash",
        text,
        url: INVITE_URL,
        dialogTitle: t("shareDialog"),
      });
      return;
    } catch {
      /* fall through — user cancelled or share unavailable */
    }
  }

  if (typeof navigator !== "undefined" && navigator.share) {
    try {
      await navigator.share({ title: "3Dash", text, url: INVITE_URL });
      return;
    } catch {
      /* cancelled */
      return;
    }
  }

  try {
    await navigator.clipboard?.writeText(text);
    alert(t("shareCopied"));
  } catch {
    alert(text);
  }
}
